const baseURL = 'https://restaurante.chatmeagent.com/';

export default baseURL;
